import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import EmployeeMultiFilters from 'modules/core/components/EmployeeMultiFilters'
import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import type { FilterOption as MultiFilterOption } from 'modules/core/components/MultiFilters/types'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import FilterPopover from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/CommandsFilterBar//FilterPopover'
import LocationSelector from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/CommandsFilterBar/LocationSelector'
import filterFields from 'modules/shift_management/components/ShiftManagement/Content/_filters/filterFields'
import {
  SHIFT_CONFLICTS,
  SHIFT_WITHOUT_CONFLICTS,
} from 'modules/shift_management/hooks/reducers/filter'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

import * as styles from './index.vanilla.css'

interface Props {
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  disabled?: boolean
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: () => void
  onCancel: () => void
  onResetFilters: () => void
}

const OldMultiFiltersSelector = observer(
  ({
    filters,
    logicOperator,
    disabled,
    onAddFilter,
    onRemoveFilter,
    onApplyFilters,
    onCancel,
    onResetFilters,
  }: Props) => {
    const [popoverOpen, setPopoverOpen] = React.useState<boolean>(false)
    const [{ view }] = useSchedule()
    const [{ hasFeatureFlag }] = useEnabledFeatures()
    const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')

    const [fields, setFields] = React.useState<readonly MultiFilterOption[]>([])

    const { loading } = useAsyncData(async () => {
      const allFields = await filterFields(statusOptions)

      const newFields = newEntryFlowEnabled
        ? allFields.filter((field) => field.value !== 'location')
        : allFields

      setFields(newFields)
    }, [])

    const statusOptions = [
      {
        value: SHIFT_CONFLICTS,
        label: i18n.t('shift_management.filters.shift_conflicts'),
      },
      {
        value: SHIFT_WITHOUT_CONFLICTS,
        label: i18n.t('shift_management.filters.shift_without_conflicts'),
      },
    ]

    if (popoverOpen) {
      track(trackingEvents.shiftManagement.filterShiftManagementStart, {
        view: view.viewType,
        view_type_by: view.groupType,
      })
      setPopoverOpen(false)
    }

    {
      /* Custom CSS to reduce the paddingTop/paddingBottom, remove once the component is updated from Gamma */
    }
    return (
      <>
        {newEntryFlowEnabled && (
          <Box width="s200">
            <LocationSelector />
          </Box>
        )}
        <Box minWidth={newEntryFlowEnabled ? 's0' : 's80'} className={styles.filters}>
          {loading && <Skeleton width="s140" height="s40" />}
          {!loading && (
            <>
              {newEntryFlowEnabled ? (
                <FilterPopover
                  fields={fields}
                  filters={filters}
                  logicOperator={logicOperator}
                  onAddFilter={onAddFilter}
                  onRemoveFilter={onRemoveFilter}
                  onApplyFilters={onApplyFilters}
                  onCancel={onCancel}
                />
              ) : (
                <EmployeeMultiFilters
                  label={i18n.t('filters.multi_filters.title')}
                  fields={fields}
                  filters={filters}
                  logicOperator={logicOperator}
                  disabled={disabled}
                  onAddFilter={onAddFilter}
                  onRemoveFilter={onRemoveFilter}
                  onApplyFilters={onApplyFilters}
                  onCancel={onCancel}
                  onResetFilters={onResetFilters}
                  setChildPopoverOpen={setPopoverOpen}
                  dense
                />
              )}
            </>
          )}
        </Box>
      </>
    )
  }
)

export { OldMultiFiltersSelector }
